import React from "react";
import { Link } from "react-router-dom";
import { BRAND, LOGO_URL } from "../brand";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 mt-32">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO_URL} alt="ProSource Labs — Research-Grade Peptide Supplier logo" className="h-10 w-10 object-contain" />
            <div>
              <div className="font-heading text-lg">{BRAND.name}</div>
              <div className="overline" style={{ fontSize: 9 }}>{BRAND.tagline}</div>
            </div>
          </div>
          <p className="text-sm text-[#8A94A6] max-w-md leading-relaxed">
            Precision-manufactured peptides crafted to uncompromising standards. Sold exclusively for research purposes — never for human or animal consumption.
          </p>
        </div>

        <div>
          <div className="overline mb-4">Support</div>
          <ul className="space-y-2 text-xs text-[#8A94A6] font-mono-tech uppercase tracking-wider leading-relaxed">
            <li>
              <a
                href="mailto:support@prosourcelabs.org"
                data-testid="footer-support-email"
                className="hover:text-[#00C3FF] transition-colors"
              >
                support@prosourcelabs.org
              </a>
            </li>
            <li>
              <a
                href="sms:+19519873443"
                data-testid="footer-support-sms"
                className="hover:text-[#00C3FF] transition-colors"
              >
                Text (951) 987-3443
              </a>
              <div className="text-[9px] text-[#5C657A] mt-0.5 tracking-wider">Text Only · Mon–Fri 9AM–6PM PT</div>
            </li>
          </ul>

          <div className="overline mt-6 mb-4">Legal</div>
          <ul className="space-y-2 text-xs text-[#8A94A6] font-mono-tech uppercase tracking-wider leading-relaxed">
            <li><Link to="/terms" data-testid="footer-link-terms" className="hover:text-[#00C3FF] transition-colors">Terms &amp; Conditions</Link></li>
            <li><Link to="/disclaimer" data-testid="footer-link-disclaimer" className="hover:text-[#00C3FF] transition-colors">Disclaimer</Link></li>
            <li><Link to="/refund-policy" data-testid="footer-link-refund" className="hover:text-[#00C3FF] transition-colors">Refund Policy</Link></li>
          </ul>
          <div className="overline mt-6 mb-3">Disclaimers</div>
          <ul className="space-y-2 text-[10px] text-[#5C657A] font-mono-tech uppercase tracking-wider leading-relaxed">
            <li>21+ Access Required</li>
            <li>For Research Use Only</li>
            <li>Not For Human Consumption</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5 py-6 px-6 max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="text-xs text-[#5C657A] font-mono-tech">© {new Date().getFullYear()} ProSource Labs. All rights reserved.</div>
        <div className="text-[10px] font-mono-tech tracking-[0.2em] text-[#00C3FF]">PRECISION · PURITY · PERFORMANCE</div>
      </div>
    </footer>
  );
}

